import React from 'react';
import { observer } from 'mobx-react';
import {Box, Grid} from '@mui/material';
import CompletionProgressBar from '../../../components/CompletionProgressBar';
import FormSkeleton from '../../../components/FormSkeleton';
import useFeature from '../../../useFeature';
import {useApplication} from "../../../ApplicationProvider";
import FormFileField from "../../../components/fileUploadComponents/FormFileField";
import FormRow from "../../../forms/FormRow";
import FormAutocompleteField from "../../../components/fields/FormAutocompleteField";
import FormColumn from "../../../forms/FormColumn";
import FormSection from "../../../forms/FormSection";
import FormAutocompleteMultipleSelectField from "../../../components/fields/FormAutocompleteMultipleSelectField";

function TaxDataPanel({generalFeature}) {
    const application = useApplication();
    const feature = useFeature(() => generalFeature.features['TaxDataPanelFeature'])

    const isFeatureReady = (feature) => {
        return feature && feature.loaded;
    }

    if (!isFeatureReady(feature)) {
        return (
            <FormSkeleton
                rows={2}
                fieldsPerRow={2}
            />
        );
    }

    const form = feature.form;
    return (
        <Box p={3} display="flex" flexDirection="column" gap={3}>
            <CompletionProgressBar form={form} />
            <FormSection title="IVA">
                <FormColumn>
                    <FormRow>
                        <FormAutocompleteField
                            label="Condición frente al IVA"
                            form={form}
                            fieldName={"ivaCondition"}
                            options={feature.ivaConditionOptions()}
                        />
                    </FormRow>
                </FormColumn>
            </FormSection>
            <FormSection title="Ingresos Brutos">
                <FormColumn>
                    <FormRow>
                        <FormAutocompleteField
                            label="Ingresos Brutos"
                            form={form}
                            fieldName={"rawIncome"}
                            options={feature.rawIncomeOptions()}
                        />
                        <FormAutocompleteField
                            label="Posee Certificado de Exención"
                            form={form}
                            fieldName={"exemptionCertificateOption"}
                            options={feature.yesOrNoOptions()}
                        />
                    </FormRow>
                </FormColumn>
            </FormSection>
            <FormSection title="Impuesto a las Ganancias">
                <FormColumn>
                    <FormRow>
                        <FormAutocompleteField
                            label="Impuesto a las Ganancias"
                            form={form}
                            fieldName={"incomeTax"}
                            options={feature.incomeTaxOptions()}
                        />
                    </FormRow>
                </FormColumn>
            </FormSection>
            <FormSection title="Agente de Percepción">
                <FormColumn>
                    <FormRow>
                        <FormAutocompleteMultipleSelectField
                            label={'Jurisdicciones en las que Sapore di Pane es Agente de Percepción'}
                            form={form}
                            fieldName={"provincesPerceptions"}
                            options={feature.provincesPerceptionsOptions()}
                        />
                        <FormAutocompleteField
                            label="Certificado de No Percepción"
                            form={form}
                            options={feature.yesOrNoOptions()}
                            fieldName={"nonWithholdingCertificateOption"}
                        />
                    </FormRow>
                </FormColumn>
            </FormSection>
            <Grid container gap={10}>
                <Grid item xs={10} sm={5}>
                    <FormFileField
                        key="afipRegistrationProof"
                        title="Constancia de inscripción a AFIP"
                        form={form}
                        fieldName="afipRegistrationProof"
                        placeholder="Subir archivo..."
                        singleFile
                        onBlur={() => feature.editTaxData()}
                    />
                </Grid>

                <Grid item xs={10} sm={5}>
                    <FormFileField
                        key="grossIncomeTaxRegistrationProof"
                        title="Constancia de Ingresos Brutos"
                        form={form}
                        fieldName="grossIncomeTaxRegistrationProof"
                        placeholder="Subir archivo..."
                        singleFile
                        onBlur={() => feature.editTaxData()}
                    />
                </Grid>

                <Grid item xs={10} sm={5}>
                    <FormFileField
                        key="exemptionsCertificate"
                        title="Certificado de Excepción"
                        form={form}
                        fieldName="exemptionsCertificate"
                        placeholder="Subir archivo..."
                        isRequired={feature.needsExemptionsCertificate()}
                        singleFile
                        onBlur={() => feature.editTaxData()}
                    />
                </Grid>

                <Grid item xs={10} sm={5}>
                    <FormFileField
                        key="cm01form"
                        title="Formulario CM01"
                        form={form}
                        fieldName="cm01form"
                        placeholder="Subir archivo..."
                        singleFile
                        onBlur={() => feature.editTaxData()}
                    />
                </Grid>

                <Grid item xs={10} sm={5}>
                    <FormFileField
                        key="cm05form"
                        title="Formulario CM05"
                        form={form}
                        fieldName="cm05form"
                        placeholder="Subir archivo..."
                        singleFile
                        onBlur={() => feature.editTaxData()}
                    />
                </Grid>

                <Grid item xs={10} sm={5}>
                    <FormFileField
                        key="nonWithholdingCertificate"
                        title="Certificado de No Percepción"
                        form={form}
                        fieldName="nonWithholdingCertificate"
                        placeholder="Subir archivo..."
                        isRequired={feature.needsNonWithholdingCertificate()}
                        singleFile
                        onBlur={() => feature.editTaxData()}
                    />
                </Grid>
            </Grid>
        </Box>
    );
}

export default observer(TaxDataPanel);
